import { useFilterResults, useFilters } from 'map-filter-view'
import numeral from 'numeral'
import { useDispatch } from 'react-redux'
import { MapFilterButton as View } from 'ui-components'
import {
  openMapFilterDrawer,
  useIsMapFilterDrawerOpen
} from '~map-preview/states/ui'

export const MapFilterButton = () => {
  const dispatch = useDispatch()

  const filters = useFilters()
  const filterResults = useFilterResults()
  const open = useIsMapFilterDrawerOpen()

  const resultsCount = filters.length
    ? numeral(filterResults.length).format('0.a')
    : undefined

  const handleClick = () => {
    dispatch(openMapFilterDrawer())
  }

  return (
    <View
      active={open}
      resultsCount={resultsCount}
      onClick={handleClick}
    />
  )
}
